// extracted by mini-css-extract-plugin
export var external = "VCButton-module--external--ce9fz";
export var mainWrapper = "VCButton-module--mainWrapper---zikG";